/**
 * CSS样式注入函数
 * @returns
 */
const injectStyles = (): void => {
  if (document.querySelector('style[data-error-overlay]')) {
    return;
  }

  const style = document.createElement('style');
  style.setAttribute('data-error-overlay', 'true');
  style.textContent = `
      .resource_error-container {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999999;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      .resource_error-container .icon {
        width: 240px;
      }
      .resource_error-container .icon img {
        display: block;
        width: 100%;
      }
      .resource_error-container h3 {
        text-align: center;
        font-size: 14px;
        color: #999;
        padding: 15px 0;
      }
      .resource_error-container .button {
        cursor: pointer;
        width: 120px;
        height: 36px;
        background-color: #f03036;
        border-radius: 4px;
        line-height: 36px;
        text-align: center;
        color: #fff;
        user-select: none;
      }
      .resource_error-container .button:hover {
        background-color: #f56e72;
      }
    `;
  document.head.appendChild(style);
};

/**
 * 创建遮罩层
 */
const createOverlay = (): void => {
  injectStyles();

  if (document.querySelector('.resource_error-container')) {
    return;
  }

  const errorIcon = document.createElement('img');
  errorIcon.src = '//zhyt-hrhg.9635.com.cn/images/resource_error.png';

  const errorIconDiv = document.createElement('div');
  errorIconDiv.appendChild(errorIcon);
  errorIconDiv.setAttribute('class', 'icon');

  const errorText = document.createElement('h3');
  errorText.innerText = '当前页面资源加载异常';

  const reloadButton = document.createElement('div');
  reloadButton.id = 'errorReloadButton';
  reloadButton.innerText = '重新加载';
  reloadButton.setAttribute('class', 'button');

  const resourceErrorContainer = document.createElement('div');
  resourceErrorContainer.setAttribute('class', 'resource_error-container');

  resourceErrorContainer.appendChild(errorIconDiv);
  resourceErrorContainer.appendChild(errorText);
  resourceErrorContainer.appendChild(reloadButton);

  document.body.appendChild(resourceErrorContainer);

  const errorReloadButtonEle = document.getElementById('errorReloadButton');
  if (!errorReloadButtonEle) {
    return;
  }

  errorReloadButtonEle.onclick = () => {
    if (window.ClientBridge && window.ClientBridge.clearchace) {
      window.ClientBridge.clearchace();
      return;
    }
    const url: URL = new URL(window.location.href);
    const timeStamp: number = new Date().getTime();
    url.searchParams.set('t', timeStamp.toString());
    window.location.replace(url.toString());
  };
};

/**
 * 展示错误遮罩层
 */
export const showErrorOverlay = (): void => {
  if (document.querySelector('.resource_error-container')) {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createOverlay);
  } else {
    createOverlay();
  }
};
